(() => {
  if (window.__ofraNewProductInitialized) return;
  window.__ofraNewProductInitialized = true;

  let productSwiper = null;
  let swiperHost = null;
  let productSwiperDesktop = null;
  let desktopSwiperHost = null;
  let mediaObserver = null;
  let ticking = false;

  const getRoot = (scope = document) => {
    if (!scope) return null;

    if (scope.matches && scope.matches('.new-product')) return scope;

    return scope.querySelector('.new-product');
  };

  const updateScrollbarTrackWidth = (root, percentage) => {
    const widthContainer = root.querySelector('.new-product__scrollbar-track');
    if (!widthContainer) return;

    widthContainer.style.width = `${percentage}%`;
  };

  const getRealSlidesCount = (swiperInstance) => {
    const realSlides = Array.from(swiperInstance.slides).filter(
      (slide) => !slide.classList.contains('swiper-slide-duplicate')
    );

    return realSlides.length;
  };

  const destroySwiper = () => {
    if (!productSwiper) return;

    productSwiper.destroy(true, true);
    productSwiper = null;
    swiperHost = null;
  };

  const ensureSwiper = (root) => {
    const host = root.querySelector('.product-swiper');

    if (!host || typeof window.Swiper === 'undefined') {
      destroySwiper();
      return;
    }

    if (window.innerWidth > 991) {
      destroySwiper();
      return;
    }

    if (productSwiper && swiperHost === host) {
      productSwiper.update();
      return;
    }

    destroySwiper();
    swiperHost = host;

    productSwiper = new window.Swiper(host, {
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: root.querySelector('.swiper-pagination'),
        clickable: true,
      },
      observer: true,
      observeParents: true,
      on: {
        init() {
          const totalSlides = getRealSlidesCount(this);
          if (!totalSlides) return;
          updateScrollbarTrackWidth(root, (1 / totalSlides) * 100);
        },
        slideChange() {
          const totalSlides = getRealSlidesCount(this);
          if (!totalSlides) return;
          const widthPercentage = ((this.realIndex + 1) / totalSlides) * 100;
          updateScrollbarTrackWidth(root, widthPercentage);
        },
      },
    });

    const prevBtn = root.querySelector('.new-product__arrow-mobile .bestsellers-slider__btn--prev');
    const nextBtn = root.querySelector('.new-product__arrow-mobile .bestsellers-slider__btn--next');
    if (prevBtn && !prevBtn.dataset.mtlBound) {
      prevBtn.dataset.mtlBound = '1';
      prevBtn.addEventListener('click', function () { productSwiper.slidePrev(); });
    }
    if (nextBtn && !nextBtn.dataset.mtlBound) {
      nextBtn.dataset.mtlBound = '1';
      nextBtn.addEventListener('click', function () { productSwiper.slideNext(); });
    }
  };

  const destroyDesktopSwiper = () => {
    if (!productSwiperDesktop) return;

    productSwiperDesktop.destroy(true, true);
    productSwiperDesktop = null;
    desktopSwiperHost = null;
    window.productSwiperDesktop = null;
  };

  const ensureDesktopSwiper = (root) => {
    const host = root.querySelector('.product-swiper-desktop');

    if (!host || typeof window.Swiper === 'undefined') {
      destroyDesktopSwiper();
      return;
    }

    if (window.innerWidth < 992) {
      destroyDesktopSwiper();
      return;
    }

    if (productSwiperDesktop && desktopSwiperHost === host) {
      productSwiperDesktop.update();
      return;
    }

    destroyDesktopSwiper();
    desktopSwiperHost = host;

    productSwiperDesktop = new window.Swiper(host, {
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: root.querySelector('.new-product__nav-btn--prev'),
        nextEl: root.querySelector('.new-product__nav-btn--next'),
      },
    });

    window.productSwiperDesktop = productSwiperDesktop;
  };

  // Barra de progreso vertical del gallery apilado (usada por main-product-gift).
  // Inerte en el PDP principal, que ya no tiene .new-product__custom-scrollbar.
  const syncMediaScroll = (root, { setInitial = false } = {}) => {
    const mediaContainer = root.querySelector('.new-product__media');
    const customScrollbar = root.querySelector('.new-product__custom-scrollbar');
    if (!mediaContainer || !customScrollbar) return;

    if (setInitial) {
      customScrollbar.style.height = '8%';
      updateScrollbarTrackWidth(root, 25);
    }

    const windowHeight = window.innerHeight;
    const documentHeight = Math.max(1, document.documentElement.scrollHeight - windowHeight);
    const scrolled = window.pageYOffset;
    const scrollPercentage = (scrolled / documentHeight) * 45;

    const maxScroll = mediaContainer.scrollHeight - mediaContainer.clientHeight;
    mediaContainer.scrollTop = maxScroll * scrollPercentage;
    customScrollbar.style.height = `${scrollPercentage * 8}%`;
  };

  const updateScrollbarVisibility = (root) => {
    const targetNode = root.querySelector('.new-product__media');
    const scrollbarWrapper = root.querySelector('.new-product__scrollbar-wrapper');
    if (!targetNode || !scrollbarWrapper) return;

    const imageCount = targetNode.getElementsByTagName('img').length;
    scrollbarWrapper.style.display = imageCount === 1 ? 'none' : '';
  };

  const observeMediaChanges = (root) => {
    mediaObserver?.disconnect();
    mediaObserver = null;

    const triggerElement = root.querySelector('.product-form__input--dropdown');
    if (!triggerElement) return;

    const targetNode = root.querySelector('.new-product__media');
    const scrollbarWrapper = root.querySelector('.new-product__scrollbar-wrapper');
    if (!targetNode || !scrollbarWrapper) return;

    mediaObserver = new MutationObserver((mutationsList) => {
      if (mutationsList.some((mutation) => mutation.type === 'childList')) {
        updateScrollbarVisibility(root);
      }
    });

    mediaObserver.observe(targetNode, { childList: true, subtree: true });
    updateScrollbarVisibility(root);
  };

  const initNewProductUI = (scope = document) => {
    const root = getRoot(scope) || getRoot(document);
    if (!root) {
      destroySwiper();
      destroyDesktopSwiper();
      mediaObserver?.disconnect();
      mediaObserver = null;
      return;
    }

    ensureSwiper(root);
    ensureDesktopSwiper(root);
    syncMediaScroll(root, { setInitial: true });
    observeMediaChanges(root);
  };

  const onResize = () => {
    initNewProductUI(document);
  };

  const onScroll = () => {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(() => {
      const root = getRoot(document);
      if (root) syncMediaScroll(root);
      ticking = false;
    });
  };

  const boot = () => {
    initNewProductUI(document);
    window.addEventListener('resize', onResize);
    window.addEventListener('scroll', onScroll, { passive: true });

    document.addEventListener('product-info:loaded', (event) => {
      initNewProductUI(event.target);
    });

    document.addEventListener('shopify:section:load', (event) => {
      initNewProductUI(event.target);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
